var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9564 1.58763C20.8529 0.5705 18.493 0 15.9999 0C13.5068 0 11.1469 0.5705 9.04341 1.58763L7.6521 16L9.04341 30.4124C11.1469 31.4295 13.5068 32 15.9999 32C18.493 32 20.8529 31.4295 22.9564 30.4124L24.3477 16L22.9564 1.58763Z",
    fill: "#FFDA44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0435 1.5882C3.69163 4.17607 0 9.65663 0 16C0 22.3434 3.69163 27.8239 9.0435 30.4118V1.5882Z",
    fill: "#0052B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9565 1.5882V30.4118C28.3084 27.8239 32 22.3433 32 16C32 9.6567 28.3084 4.17607 22.9565 1.5882Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8694 9.73921L21.8028 10.2058L20.8694 9.73921L19.9361 9.27259C19.8798 9.38515 18.6611 11.8647 18.4621 15.6523H17.0434V9.73921L15.9999 8.3479L14.9564 9.73921V15.6523H13.5377C13.3386 11.8647 12.12 9.38515 12.0636 9.27259L10.197 10.2059C10.2099 10.2315 11.4782 12.8131 11.4782 16.6958V17.7393H14.9565V23.6523H17.0434V17.7393H20.5216V16.6957C20.5216 14.6883 20.8689 13.0331 21.1604 11.998C21.4781 10.8692 21.8008 10.21 21.8039 10.2035L20.8694 9.73921Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBb);
export default __webpack_public_path__ + "static/media/BB.86fa8185.svg";
export { ForwardRef as ReactComponent };